import React from 'react';

import AuthLayout from 'components/authentication/AuthLayout';
import LoginForm from 'components/authentication/LoginForm';


const LoginPage = () => (
  <AuthLayout type="login" className="login-page__component">
    <LoginForm />
  </AuthLayout>
);

export default LoginPage;
